var map = {
	"./app-fill.svg": "1d66",
	"./arrowLeft.svg": "1a97",
	"./arrowRight.svg": "1bae",
	"./attachment.svg": "8589",
	"./bottom.svg": "3570",
	"./bulb-fill.svg": "d99a",
	"./bulb.svg": "f5b0",
	"./email.svg": "da8d",
	"./flag-fill.svg": "0961",
	"./heart-fill.svg": "6143",
	"./heart.svg": "6768",
	"./home-fill.svg": "69e1",
	"./language.svg": "c7a8",
	"./mail-fill.svg": "13f6",
	"./mobile-phone.svg": "090b",
	"./navigation.svg": "90e2",
	"./notification.svg": "720f",
	"./switch.svg": "beac",
	"./takeLeave.svg": "266f",
	"./user.svg": "4d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";